module.exports = __webpack_public_path__ + "img/butterfly.24d7754.svg";